import { useEffect, useState } from 'react'

interface Dimensions {
    height: number
    width: number
}

export function useDimensions(): Dimensions {
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight - 71,
        width: window.innerWidth
    })

    useEffect(() => {
        function handleResize(): void {
            setDimensions({
                height: window.innerHeight - 71, // 71 live header
                width: window.innerWidth
            })
        }

        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return dimensions
}
